import CryptoJs from "crypto-js"
const { REACT_APP_MSAL_SECRET_VALUE } = process.env;
export const encryptData = (data) => {
    try {
        return CryptoJs.AES.encrypt(JSON.stringify(data), REACT_APP_MSAL_SECRET_VALUE).toString();
    } catch (error) {
        return null
    }
}

export const decryptData = (cipherText) => {
    try {
        const bytes = CryptoJs.AES.decrypt(cipherText, REACT_APP_MSAL_SECRET_VALUE);
        return JSON.parse(bytes.toString(CryptoJs.enc.Utf8))
    } catch (error) {
        return null
    }
}

export const encryptAuthData = (string) => {
    try {
        return CryptoJs.enc.Base64.stringify(CryptoJs.enc.Utf8.parse(string));
    } catch (error) {
        return null;
    }
}